document.addEventListener('DOMContentLoaded', () => {
  const chooseBtn = document.getElementById('cf-choose-image');
  const realInput = document.getElementById('cf-file-input');
  const previewContainer = document.getElementById('cf-preview-container');
  const previewFrame = document.querySelector('.cf-preview-frame');
  const previewImg = document.getElementById('cf-preview-img');
  const progressText = document.getElementById('cf-progress-text');

  if (!chooseBtn || !realInput) return;
  chooseBtn.addEventListener('click', () => realInput.click());

  realInput.addEventListener('change', async function () {
    const file = this.files?.[0];
    if (!file) return;

    previewContainer.style.display = 'flex';
    previewFrame.classList.add('uploading');
    progressText.textContent = 'Uploading 0%';

    // Simulate upload progress (replace later with real API progress)
    let progress = 0;
    const fake = setInterval(() => {
      progress += 10;
      progressText.textContent = `Uploading ${progress}%`;
      if (progress >= 100) {
        clearInterval(fake);
        setTimeout(() => showPreview(file), 400);
      }
    }, 200);
  });

  function showPreview(file) {
    const reader = new FileReader();
    reader.onload = e => {
      previewFrame.classList.remove('uploading');
      previewImg.src = e.target.result;
      previewImg.style.opacity = 1;
      previewFrame.classList.add('show-watermark');
    };
    reader.readAsDataURL(file);
  }

  // Drag & drop
  document.addEventListener('dragover', e => e.preventDefault());
  document.addEventListener('drop', e => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length) {
      realInput.files = files;
      realInput.dispatchEvent(new Event('change',{bubbles:true}));
    }
  });
});